try {
// ============================================================
// supabase-ket-noi.js — cầu nối Supabase: đăng nhập Google,
// theo dõi phiên, hiện khu tài khoản trên đầu trang.
// Khi chưa nối CSDL (DA_NOI = false) file này không làm gì cả —
// trang chạy chế độ xem thử như cũ.
// ============================================================
(function () {
  'use strict';

  function thoat(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ⛔ HÀNG RÀO 1 — js/cauhinh.js phải chạy TRỌN VẸN thì mới tin được các cờ
  //    bên dưới. Cờ vắng mặt không có nghĩa là "trường chưa nối CSDL", nó cũng
  //    có thể nghĩa là "tệp cấu hình chưa chạy" — và lúc đó ta chưa biết gì cả,
  //    phải đóng. Xem khối chú thích cuối js/cauhinh.js.
  //    Hỏng ở đây thì trang treo mãi ở màn "Đang tải…" — đó là hỏng ĐÚNG hướng:
  //    thà không vào được còn hơn mở toang.
  if (window.CAU_HINH_XONG !== true) return;
  if (!window.CAU_HINH_SAN_SANG) return;

  var may = null;
  window.NGUOI_DUNG = null;

  // ══════════ CỔNG VÀO ══════════
  var LOGO_GOOGLE =
    '<svg viewBox="0 0 48 48" aria-hidden="true">' +
    '<path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>' +
    '<path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>' +
    '<path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>' +
    '<path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>' +
    '</svg>';

  function hopCong() {
    // Cổng công khai (js/cong-khai.js) đang che màn → gỡ trước khi vẽ hộp đăng nhập
    // nào. Riêng lúc người đã đăng nhập tự mở xem cổng (CHE_DO 'xem'/'thu') thì cổng
    // không đi qua đây, nên gỡ ở đây không làm mất cổng của họ.
    if (window.CONG_KHAI && window.CONG_KHAI.dangMo() && !dangXemCong) window.CONG_KHAI.dong();
    return document.getElementById('cong-hop');
  }
  var dangXemCong = false;

  function dauCong() {
    var C = window.CAU_HINH || {};
    return '<img class="logo dien-logo" src="' + thoat((C.THU_MUC_ANH || 'img/') + 'logo.png') +
      // Trường chưa gửi logo riêng → quay về biểu trưng TRUNG TÍNH.
      // Từ 20/8/2026 img/logo.png cũng chính là logo Quản trị số nên hai đường
      // ra cùng một hình; vẫn giữ đường dự phòng để trường nào thả logo riêng
      // vào img/<mã>/logo.png là dùng được ngay, thiếu tệp cũng không vỡ giao diện.
      '" alt="" onerror="this.onerror=null;this.src=\'img/he-thong.svg\'">' +
      '<h1>Hệ thống Quản trị số<br><span class="dien-ten-truong">' +
      thoat(C.TEN_TRUONG) + '</span></h1>';
  }

  function chanCong() {
    // ⛔ KHÔNG bày ô chọn trường ở đây. App dùng chung cho nhiều trường, nhưng
    //    mỗi trường phải thấy MỘT MÌNH mình: thầy cô Diễn Liên không việc gì
    //    phải biết trường Châu Đình cũng dùng app này, và ngược lại.
    //    Phân biệt trường bằng ĐỊA CHỈ (tên miền riêng, hoặc ?truong=<mã> mà
    //    nhà trường cấp cho thầy cô), không bằng ô chọn. Xem §12.6 bản kế hoạch.
    //    Riêng khi trường KHÔNG được nhận ra từ tên miền — tức người dùng đang ở
    //    một địa chỉ dùng chung và đã tự khai mã — thì phải có ĐƯỜNG LÙI: gõ
    //    nhầm mã một lần là máy nhớ, không có nút này thì kẹt vĩnh viễn ở cổng
    //    trường lạ. Đây là một ĐƯỜNG DẪN, không phải danh sách — không lộ tên ai.
    // href tương đối chỉ-truy-vấn — không ghép location.pathname (pathname dạng
    // //evil.com/ ghép vào là thành địa chỉ tuyệt đối sang tên miền khác).
    var lui = (window.THEO_TEN_MIEN !== true)
      ? '<div class="cong-lui"><a href="?doitruong=1">' +
        '↩ Không phải trường của thầy cô? Nhập lại mã trường</a></div>'
      : '';
    return lui + '<div class="chan">Nhà trường <b>không lưu giữ mật khẩu</b> Gmail của thầy cô. ' +
      'Việc xác thực do Google thực hiện. Dữ liệu cá nhân được bảo vệ theo ' +
      'Luật Bảo vệ dữ liệu cá nhân năm 2025.</div>';
  }

  // Trang chỉ mở khi tài khoản ĐÃ đăng nhập VÀ đang hoạt động
  function moKhoa() {
    // Cổng chế độ 'cho' (Gmail chờ duyệt xem như khách) mà nay đã được duyệt → đóng cổng, vào hệ thống
    var laCho = window.CONG_KHAI && window.CONG_KHAI.cheDo && window.CONG_KHAI.cheDo() === 'cho';
    if (window.CONG_KHAI && (!dangXemCong || laCho)) { window.CONG_KHAI.dong(); if (laCho) dangXemCong = false; }
    document.body.classList.remove('dang-khoa');
    var cong = document.getElementById('cong-vao');
    if (cong) cong.classList.add('an');
  }

  function veCongDangNhap(loi) {
    var h = hopCong(); if (!h) return;
    h.innerHTML = dauCong() +
      '<div class="loi-moi">Đăng nhập bằng địa chỉ Gmail của thầy cô để vào hệ thống.</div>' +
      '<button class="nut-google" id="nut-google">' + LOGO_GOOGLE + ' Đăng nhập bằng Google</button>' +
      (loi ? '<div class="hop-loi khoa">' + thoat(loi) + '</div>' : '') +
      chanCong();
    document.getElementById('nut-google').addEventListener('click', function () {
      this.disabled = true;
      this.innerHTML = 'Đang chuyển sang Google…';
      dangNhap();
    });
  }

  // Tài khoản KHÁCH KIỂM TRA (sql/82): luôn 'khoa' — nếu còn hạn thì mở màn chỉ xem minh
  // chứng (js/khach-kiem-tra.js), trang app VẪN khoá. Trường chưa chạy 82 / không phải khách
  // / hết hạn → hộp chờ duyệt / bị khoá như cũ.
  function choDuyetHoacKhach(email, laKhoa) {
    if (!window.KHACH_XEM || !may) { choHoacCong(email, laKhoa); return; }
    Promise.resolve(may.rpc('khach_toi')).then(function (r) {
      if (r && !r.error && r.data) { dangXemCong = true; window.KHACH_XEM.mo(may, r.data, dangXuat); }
      else choHoacCong(email, laKhoa);
    }, function () { choHoacCong(email, laKhoa); });
  }

  // Gmail chưa có trong danh sách CBGV (chờ duyệt) → coi như KHÁCH: đưa về cổng công khai kèm
  // một dòng báo + nút Đăng xuất (thầy Chung 5/10/2026). Trường chưa công bố mục nào, hoặc tài
  // khoản bị khoá → giữ màn báo cũ. Không đổi quyền: RLS vẫn chỉ cho đọc bản công bố.
  function choHoacCong(email, laKhoa) {
    if (laKhoa || !window.CONG_KHAI || !window.CONG_KHAI.choDuyet || !may) { veCongChoDuyet(email, laKhoa); return; }
    dangXemCong = true;
    window.CONG_KHAI.choDuyet(may, email, dangXuat).then(function (co) {
      if (!co) { dangXemCong = false; veCongChoDuyet(email, laKhoa); }
    }, function () { dangXemCong = false; veCongChoDuyet(email, laKhoa); });
  }

  function veCongChoDuyet(email, laKhoa) {
    var h = hopCong(); if (!h) return;
    h.innerHTML = dauCong() +
      '<div class="loi-moi">' + (laKhoa ? '🔒 Tài khoản đã bị khóa' : '🕐 Tài khoản đang chờ duyệt') + '</div>' +
      '<div class="hop-loi ' + (laKhoa ? 'khoa' : 'cho') + '">' +
      '<b>' + thoat(email) + '</b><br>' +
      (laKhoa
        ? 'Tài khoản này đã bị khóa. Thầy cô liên hệ Ban giám hiệu để được mở lại.'
        : 'Thầy cô đã đăng nhập thành công, nhưng địa chỉ Gmail này chưa có trong ' +
          'danh sách của nhà trường nên cần Ban giám hiệu duyệt. Nếu thầy cô dùng ' +
          'Gmail khác với địa chỉ đã đăng ký, hãy đăng xuất rồi đăng nhập lại đúng địa chỉ đó.' +
          // Trường vừa mở: người được nhà trường khai làm quản trị mà vẫn dừng
          // ở đây thì gần như chắc chắn địa chỉ khai trong đơn khác địa chỉ vừa
          // đăng nhập. Nói thẳng ra, đừng để họ ngồi đợi một lời duyệt không
          // bao giờ tới — trường mới chưa có ai đủ quyền mà duyệt cả.
          '<br><br>Nếu thầy cô là <b>người nhà trường cử làm quản trị</b> mà vẫn thấy màn ' +
          'hình này: địa chỉ vừa đăng nhập khác với địa chỉ nhà trường ghi trong đơn đăng ký. ' +
          'Thầy cô đăng nhập lại đúng địa chỉ đó, hoặc báo người phụ trách hệ thống.' +
          // Người vào nhầm địa chỉ trường khác dừng đúng ở đây — nhắc một câu để
          // họ tìm đường về, nhưng KHÔNG nêu tên trường nào cả.
          // Trước câu này chỉ hiện khi đếm được ≥2 trường trong window.DS_TRUONG;
          // mảng đó nay đã bỏ nên đếm mãi ra 0 và câu nhắc không bao giờ hiện.
          '<br><br>Nếu thầy cô công tác ở trường khác: mỗi trường có một hệ thống ' +
          'và một đường dẫn riêng — thầy cô mở đúng đường dẫn nhà trường mình đã cấp.') +
      '</div>' +
      '<button class="nut-phu" id="nut-thoat-cong">↩ Đăng xuất</button>' +
      chanCong();
    document.getElementById('nut-thoat-cong').addEventListener('click', dangXuat);
  }

  // ── ĐÃ GỠ: nút "Tôi là quản trị viên của trường" (22/8/2026, thầy Chung chốt)
  // Trước đây cơ sở dữ liệu mới chưa có quản trị viên thì người ĐẦU TIÊN đăng
  // nhập Google bấm một nút là thành admin (sql/36 + sql/37). Lỗ hổng không nằm
  // ở kỹ thuật mà ở quy trình: gửi đường dẫn cho nhà trường, một giáo viên tò
  // mò bấm vào trước Hiệu trưởng là người đó thành quản trị — và cửa đóng vĩnh
  // viễn, sửa phải vào SQL Editor.
  //
  // Nay quyền quản trị do ADMIN HỆ THỐNG cấp: nhà trường khai "Địa chỉ Gmail
  // của người quản trị" trong đơn đăng ký, người dựng cơ sở dữ liệu gieo sẵn
  // địa chỉ ấy vào danh sách mời với vai trò 'admin' (sql/51, hàm
  // gieo_quan_tri). Người đó đăng nhập là vào thẳng, không phải bấm gì.
  //
  // Nghĩa là màn "chờ duyệt" ở trên KHÔNG còn lối rẽ nào nữa — ai thấy nó thì
  // đúng là chưa được cấp quyền, và câu chữ ở đó phải tự nó đủ chỉ đường.

  // ══════════ CỔNG CÔNG KHAI TT 09/2024 (sổ dự án 121) ══════════
  // Người CHƯA đăng nhập: trường đã công bố nội dung công khai (sql/80) thì hiện cổng
  // công khai, nút "Đăng nhập CBGV" trên cổng gọi dangNhap(). Chưa có bảng hoặc chưa
  // công bố mục nào → hộp đăng nhập như cũ. Trang VẪN khoá (body.dang-khoa) suốt lúc
  // cổng hiện: cổng chỉ đọc bảng cong_khai, không mở dữ liệu nào của app.
  var luotCong = 0;
  function moCongNgoai() {
    if (!window.CONG_KHAI || !may) { veCongDangNhap(); return; }
    var luot = ++luotCong;
    window.CONG_KHAI.thu(may, dangNhap).then(function (co) {
      if (luot !== luotCong || window.NGUOI_DUNG) return;   // phiên đã tới trong lúc chờ
      if (!co) veCongDangNhap();
    });
  }

  function veCongDangTai(chu) {
    var h = hopCong(); if (!h) return;
    h.innerHTML = dauCong() + '<div class="dang-cho">' +
      thoat(chu || 'Đang tải dữ liệu nhà trường…') + '</div>';
  }

  // ══════════ THỬ LẠI KHI MÁY CHỦ TRẢ LỖI CHỚP NHOÁNG ══════════
  // Vé đăng nhập do máy XÁC THỰC (GoTrue) ký, nhưng máy soi vé lại là máy DỮ
  // LIỆU (PostgREST) — hai máy khác nhau, mỗi máy một đồng hồ. Lệch nhau vài
  // giây thôi là cái vé vừa ký xong đã bị coi là "ký ở tương lai"
  // (JWT issued at future) và bị chặn sạch mọi câu đọc.
  //
  // Thầy Chung gặp ở Châu Đình 23/8/2026: cổng vào hiện băng đỏ, đứng đúng một
  // phút, bấm tải lại trang mới vào được. Lỗi TỰ HẾT sau ít giây — bắt người
  // dùng bấm tải lại là giao việc của máy cho người, mà người thì không biết
  // phải đợi bao lâu nên họ bấm liên tục, mỗi lần lại tải lại cả trang.
  //
  // ⛔ CHỈ thử lại đúng nhóm lỗi TỰ HẾT. Lỗi quyền (RLS chặn), thiếu bảng, sai
  //    cú pháp… thử mười lần vẫn ra đúng lỗi ấy: chỉ tổ kéo màn chờ dài ra rồi
  //    mới báo, và che mất lỗi thật khỏi mắt người đi sửa. Thêm mẫu lỗi vào
  //    danh sách dưới đây thì phải chắc chắn nó tự hết mà không cần ai làm gì.
  // Cộng lại ~70 giây, chọn theo thời gian thầy Chung phải chờ ở Châu Đình.
  //
  // ⚠️ ĐỪNG đổ cho "cơ sở dữ liệu ngủ dậy". Em đã nghĩ vậy và SAI: robot
  //    .github/workflows/giu-supabase-thuc.yml chạy đúng ngày 22/8, một ngày
  //    trước sự cố, và Châu Đình trả HTTP 200 — dự án vẫn thức. Vả lại dự án đã
  //    ngủ thật thì KHÔNG tự thức dậy được, phải có người bấm Resume project
  //    (xem mục 21.3 sổ dự án). Nguyên nhân còn lại đúng là lệch đồng hồ giữa
  //    hai máy chủ, và nó tự hết khi vé được ký lại.
  //
  // Vậy vì sao vẫn để tới 70 giây? Vì cái giá hai bên lệch hẳn nhau: thử lại
  // thừa thì thầy cô ngồi chờ thêm, có dòng chữ giải thích; thử lại thiếu thì
  // họ gặp lại đúng băng đỏ cũ và mất hẳn niềm tin vào app.
  var CHO_THU_LAI = [1200, 2500, 4000, 6000, 9000, 12000, 15000, 20000];

  function loiChopNhoang(loi) {
    if (!loi) return false;
    var m = String((loi && loi.message) || loi || '').toLowerCase();
    return (
      // Lệch đồng hồ giữa máy xác thực và máy dữ liệu — chính là lỗi ở trên
      m.indexOf('issued at future') >= 0 ||
      m.indexOf('jwsissuedatfuture') >= 0 ||
      // Mạng chập chờn: fetch ném lỗi chứ không trả về {error}
      m.indexOf('failed to fetch') >= 0 ||
      m.indexOf('networkerror') >= 0 ||
      m.indexOf('load failed') >= 0 ||
      // Máy chủ bận / đang khởi động lại
      m.indexOf('502') >= 0 || m.indexOf('503') >= 0 || m.indexOf('504') >= 0 ||
      m.indexOf('timeout') >= 0
    );
  }

  // goi() phải trả về một lời hứa. Nhận cả hai lối báo lỗi của supabase-js:
  // trả về {error: …} (lỗi từ máy chủ) và ném lỗi (đứt mạng).
  // khiCho(lanThu, soGiay) — tuỳ chọn, để nơi gọi tự nói cho người dùng biết.
  window.thuLaiSQL = function (goi, khiCho) {
    var lan = 0;
    function chay() {
      var lh;
      try { lh = Promise.resolve(goi()); } catch (e) { lh = Promise.reject(e); }
      return lh.then(function (r) {
        // Promise.all trả về MẢNG kết quả — soi từng phần tử, hỏng một là hỏng cả
        var loi = null;
        if (r && r.error) loi = r.error;
        else if (Array.isArray(r)) {
          for (var i = 0; i < r.length; i++) {
            if (r[i] && r[i].error) { loi = r[i].error; break; }
          }
        }
        if (loi && loiChopNhoang(loi) && lan < CHO_THU_LAI.length) return lui();
        return r;
      }, function (e) {
        if (loiChopNhoang(e) && lan < CHO_THU_LAI.length) return lui();
        throw e;
      });
    }
    function lui() {
      var cho = CHO_THU_LAI[lan++];
      if (khiCho) { try { khiCho(lan, Math.round(cho / 1000)); } catch (e) {} }
      return new Promise(function (ok) { setTimeout(ok, cho); }).then(chay);
    }
    return chay();
  };

  function veCongLoi(chu) {
    var h = hopCong(); if (!h) return;
    h.innerHTML = dauCong() +
      '<div class="hop-loi khoa">' + thoat(chu) + '</div>' +
      '<button class="nut-phu" id="nut-tai-lai">↻ Tải lại trang</button>' +
      chanCong();
    document.getElementById('nut-tai-lai').addEventListener('click', function () { location.reload(); });
  }

  // ── Băng thông báo trạng thái dưới đầu trang ──
  window.baoTrangThai = function (loai, chu) {
    var bang = document.getElementById('bang-trang-thai');
    if (!bang) return;
    if (!loai) { bang.style.display = 'none'; return; }
    bang.className = 'bang-trang-thai ' + loai;
    bang.innerHTML = chu;
    bang.style.display = '';
  };

  // ── Khu tài khoản góc phải đầu trang (chip + hộp xổ xuống kiểu Bạch Liêu) ──
  var TEN_VAI_TRO = {
    admin: 'Quản trị hệ thống', ban_giam_hieu: 'Ban giám hiệu', to_truong: 'Tổ trưởng chuyên môn',
    giao_vien: 'Giáo viên', nhan_vien: 'Nhân viên'
  };

  function veKhuTaiKhoan() {
    var khu = document.getElementById('khu-tai-khoan');
    if (!khu) return;
    var nd = window.NGUOI_DUNG;
    if (!nd) {
      // Nút tròn trên màn rộng (CSS ẩn chữ, chỉ còn hình chìa khóa);
      // trong bảng ☰ dưới 1000px vẫn là nút chữ đầy đủ.
      // Hướng dẫn sử dụng (huong-dan.html) đặt ngay cạnh nút Đăng nhập — người xem thử
      // cũng phải tìm thấy, không chỉ ở cổng khai mã (thầy Chung yêu cầu 06/9/2026).
      khu.innerHTML = '<a class="nut-huong-dan" href="huong-dan.html" target="_blank" rel="noopener" title="Hướng dẫn sử dụng">📖<span> Hướng dẫn</span></a>' +
        '<button class="nut-dang-nhap" id="nut-dang-nhap" title="Đăng nhập" aria-label="Đăng nhập">' +
        '<svg class="ic" viewBox="0 0 24 24"><circle cx="7.5" cy="15.5" r="4.5"/><path d="m11 12 9-9"/><path d="m17 6 3 3"/></svg>' +
        '<span>Đăng nhập</span></button>';
      document.getElementById('nut-dang-nhap').addEventListener('click', dangNhap);
      return;
    }
    var laQT = (nd.vai_tro === 'admin' || nd.vai_tro === 'ban_giam_hieu');
    khu.innerHTML =
      '<button class="nut-cong-khai" id="nut-cong-khai" type="button" hidden title="Cổng công khai — xem đúng như người ngoài nhìn thấy (Thông tư 09/2024)">' +
      '🏛<span> Cổng công khai</span></button>' +
      '<button class="chip-nguoi" id="chip-nguoi">' +
      (nd.anh_dai_dien ? '<img src="' + thoat(nd.anh_dai_dien) + '" alt="" referrerpolicy="no-referrer">' : '<span class="anh-chu">👤</span>') +
      '<span class="chip-chu"><b>' + thoat(nd.ho_ten) + '</b>' +
      '<small>' + (TEN_VAI_TRO[nd.vai_tro] || '') + '</small></span></button>' +
      '<div class="hop-tai-khoan" id="hop-tai-khoan">' +
      '<div class="phan-ten"><b>' + thoat(nd.ho_ten) + '</b>' +
      '<div class="email">' + thoat(nd.email) + '</div>' +
      '<span class="the-vai-tro">' + (TEN_VAI_TRO[nd.vai_tro] || '') + '</span></div>' +
      (laQT ? '<button class="muc-menu" id="muc-quan-tri">⚙️ Quản trị hệ thống</button>' : '') +
      '<button class="muc-menu" id="muc-cong-khai" hidden>🏛 Cổng công khai</button>' +
      // 30/9/2026: cài app lên màn hình chính (js/cai-app.js tự ẩn khi đã mở từ màn hình chính)
      '<button class="muc-menu" id="muc-cai-app" hidden>📲 Cài app lên điện thoại</button>' +
      '<a class="muc-menu" href="huong-dan.html" target="_blank" rel="noopener">📖 Hướng dẫn sử dụng</a>' +
      '<button class="muc-menu thoat" id="muc-dang-xuat">↩ Đăng xuất</button></div>';

    var hop = document.getElementById('hop-tai-khoan');
    document.getElementById('chip-nguoi').addEventListener('click', function (e) {
      e.stopPropagation();
      hop.classList.toggle('hien');
    });
    document.addEventListener('click', function () { hop.classList.remove('hien'); });
    var nutQT = document.getElementById('muc-quan-tri');
    if (nutQT) nutQT.addEventListener('click', function () {
      hop.classList.remove('hien');
      window.chuyenManHinh('quantri');
    });
    document.getElementById('muc-dang-xuat').addEventListener('click', dangXuat);
    var nutCK = document.getElementById('muc-cong-khai');
    if (nutCK && window.CONG_KHAI && may) {
      // Chỉ hiện khi bảng cong_khai có thật (trường đã chạy sql/80)
      may.from('cong_khai').select('id', { count: 'exact', head: true }).then(function (r) {
        if (!r || r.error) return;
        nutCK.hidden = false;
        // Nút tròn 🏛 cạnh ảnh đại diện (thầy Chung 4/10/2026: "tại sao phải vào Quản trị
        // mới xem được công khai?"). KHÔNG đặt trên thanh menu: màn 1920px chỉ còn ~66px
        // trống, nút có chữ (~120px) làm menu tràn và nút cuối bị khuất (đã đo trên QC1).
        var tron = document.getElementById('nut-cong-khai');
        if (tron) tron.hidden = false;
      });
      document.getElementById('nut-cong-khai').addEventListener('click', function () { window.xemCongKhai(); });
      nutCK.addEventListener('click', function () {
        hop.classList.remove('hien');
        window.xemCongKhai();
      });
    }
    if (window.CAI_APP) window.CAI_APP.ganMenu(document.getElementById('muc-cai-app'));
    // Thẻ "Quản trị hệ thống" ở trang chủ: chỉ BGH/quản trị (js/app.js, mục 100)
    if (window.apQuyenGiaoDien) window.apQuyenGiaoDien();
  }

  // Người đã đăng nhập xem cổng công khai (banNhap: BGH xem trước bản nháp —
  // js/cong-khai-soan.js truyền vào). Nút "Về hệ thống" trên cổng gỡ cổng ra.
  window.xemCongKhai = function (banNhap) {
    if (!window.CONG_KHAI || !may) return;
    dangXemCong = true;
    window.CONG_KHAI.xem(may, function () { dangXemCong = false; window.scrollTo(0, 0); }, banNhap);
  };

  function dangNhap() {
    // 🔴 PHẢI GIỮ LẠI ?truong=<mã> khi Google trả về.
    //
    // Bản cũ chỉ gửi origin + pathname, tức là RƠI MẤT phần sau dấu hỏi. Trường
    // nào vào bằng ?truong=<mã> trên tên miền của một trường khác (cách chào
    // hàng khi họ chưa có tên miền riêng) mà bấm đăng nhập, thì lúc Google trả
    // về địa chỉ chỉ còn trơ tên miền → app nhận diện theo TÊN MIỀN → họ rơi
    // vào CƠ SỞ DỮ LIỆU CỦA TRƯỜNG CHỦ TÊN MIỀN. Đăng nhập xong lại thành
    // "tài khoản chờ duyệt" ở một trường hoàn toàn xa lạ.
    //
    // Giữ nguyên cả chuỗi truy vấn là xong. Địa chỉ TRẦN thì chuỗi này rỗng nên
    // hành vi không đổi một chút nào — không đụng gì tới thầy cô đang dùng thật.
    //
    // ⚠️ Bên Supabase (Authentication → URL Configuration → Redirect URLs) phải
    //    có mẫu bao được chuỗi truy vấn, ví dụ https://<tên miền>/** — nếu chỉ
    //    khai đúng địa chỉ trần thì Google trả về sẽ bị từ chối.
    // prompt: 'select_account' — BẮT Google hỏi chọn tài khoản mỗi lần. Không có
    // nó thì máy nào đang đăng nhập sẵn một tài khoản Google là Google lẳng lặng
    // dùng luôn tài khoản ấy. Thầy cô có cả Gmail riêng lẫn mail nhà trường trên
    // cùng một điện thoại sẽ KHÔNG có đường đổi sang tài khoản kia — vào nhầm
    // rồi chỉ còn cách đăng xuất khỏi Google, việc mà ít người nghĩ ra.
    may.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: location.origin + location.pathname + (location.search || ''),
        queryParams: { prompt: 'select_account' }
      }
    });
  }

  // Xoá kho trên máy (js/kho-may.js — dữ liệu sổ chủ nhiệm) TRƯỚC khi đăng
  // xuất: máy phòng giáo viên dùng chung, người sau không được thấy lớp của
  // người trước. Kho hỏng/không có thì vẫn đăng xuất bình thường.
  function dangXuat() {
    var xoa = window.KHO_MAY ? window.KHO_MAY.xoaHet() : Promise.resolve();
    xoa.catch(function () {}).then(function () { return may.auth.signOut(); })
      .then(function () { location.reload(); });
  }

  // ── Xử lý phiên đăng nhập ──
  var idPhienDaXuLy = null;

  // ══════════ VÀO NHANH (29/9/2026) ══════════
  // Thầy Chung: "sau khi đăng nhập được rồi thì lần sau mở ra ngay". Trước đây
  // mỗi lần mở trang đều đứng ở cổng "Đang tải dữ liệu nhà trường…" chờ ĐỦ ba
  // lượt mạng: kiểm phiên Google → đọc hồ sơ tài khoản → nạp dữ liệu chung.
  // Nay: lần vào trước đã lưu hồ sơ tài khoản + dữ liệu chung vào kho trên máy
  // (js/kho-may.js). Mở trang mà trình duyệt còn giữ phiên của ĐÚNG người đó →
  // mở khoá NGAY bằng bản lưu, rồi mới hỏi máy chủ:
  //   · máy chủ nói tài khoản bị khoá / chờ duyệt / phiên hết → xoá kho, tải
  //     lại trang → cổng đăng nhập như cũ;
  //   · vai trò hay hồ sơ tài khoản đổi → lưu bản mới, tải lại trang;
  //   · dữ liệu chung đổi → du-lieu-sql.js vẽ lại, không tải lại trang;
  //   · mất mạng → băng vàng/đỏ dưới đầu trang, KHÔNG đóng cổng giữa chừng.
  // Không có bản lưu (lần đầu, quá 7 ngày, vừa đăng xuất) → đường cũ.
  var vaoNhanh = '', daVaoMang = false, phienHuy = false;

  // Đọc id tài khoản từ phiên supabase-js cất trong localStorage — KHÔNG chờ
  // getSession(), vì vé hết hạn (quá 1 giờ) thì getSession đi làm mới vé qua
  // mạng rồi mới trả lời. Đọc hỏng thì thôi, getSession vẫn lo như cũ.
  function uidDaNho() {
    try {
      var ref = new URL(window.CAU_HINH.DIA_CHI).hostname.split('.')[0];
      var o = JSON.parse(localStorage.getItem('sb-' + ref + '-auth-token') || 'null');
      var u = o && (o.user || (o.currentSession && o.currentSession.user));
      return u && u.id ? String(u.id) : '';
    } catch (e) { return ''; }
  }
  function thuVaoNhanh(uid) {
    var K = window.KHO_MAY;
    if (!K || !uid || !window.apDuLieuMay) return Promise.resolve(false);
    return Promise.all([K.doc(uid + '|vao|nd'), K.doc(uid + '|vao|du-lieu')]).then(function (x) {
      if (daVaoMang || vaoNhanh || phienHuy || (idPhienDaXuLy && idPhienDaXuLy !== uid)) return false;
      if (!x[0] || !x[1] || !x[0].v || x[0].v.id !== uid || x[0].v.trang_thai !== 'hoat_dong') return false;
      vaoNhanh = uid;
      window.NGUOI_DUNG = x[0].v;
      veKhuTaiKhoan();
      try { window.apDuLieuMay(x[1].v); } catch (e) { console.error('[Vào nhanh] áp bản lưu lỗi:', e); }
      moKhoa();
      document.dispatchEvent(new Event('dangnhap-xong'));
      window.veQuanTri && window.veQuanTri();
      return true;
    });
  }
  // Các trường chỉ máy chủ tự ghi (lần vào cuối, dấu thời gian) không tính là "đổi"
  function khacNguoi(a, b) {
    function gon(o) {
      var r = {};
      Object.keys(o || {}).sort().forEach(function (k) { if (!/lan_vao|_luc$|_at$|anh_dai_dien/.test(k)) r[k] = o[k]; });
      return JSON.stringify(r);
    }
    return gon(a) !== gon(b);
  }
  function xoaVaTaiLai() {
    var xoa = window.KHO_MAY ? window.KHO_MAY.xoaHet() : Promise.resolve();
    xoa.catch(function () {}).then(function () { location.reload(); });
  }

  function xuLyPhien(phien) {
    if (!phien) {
      window.NGUOI_DUNG = null;
      idPhienDaXuLy = null;
      phienHuy = true;
      // Đã mở trang bằng bản lưu mà phiên hoá ra đã hết → xoá kho, tải lại
      // trang cho cổng đăng nhập hiện ra sạch sẽ.
      if (vaoNhanh) { vaoNhanh = ''; xoaVaTaiLai(); return; }
      // Hết phiên (đăng xuất ở thẻ khác, vé hết hạn) → không ai đứng tên máy này
      if (window.KHO_MAY) window.KHO_MAY.xoaHet();
      moCongNgoai();
      return;
    }
    if (idPhienDaXuLy === phien.user.id) return; // tránh xử lý lặp khi đổi tab
    luotCong++;   // cổng công khai đang tải dở (nếu có) thì thôi, không dựng nữa
    // Đã vào nhanh bằng tài khoản A mà phiên thật là tài khoản B → làm lại từ đầu
    if (vaoNhanh && vaoNhanh !== phien.user.id) { vaoNhanh = ''; xoaVaTaiLai(); return; }
    idPhienDaXuLy = phien.user.id;
    // Người khác đăng nhập trên máy này → xoá kho của người trước (kho-may.js)
    if (window.KHO_MAY) window.KHO_MAY.giuNguoi(phien.user.id);
    thuVaoNhanh(phien.user.id);   // song song với lượt đọc mạng dưới đây
    var uid = phien.user.id;

    // Lượt đọc ĐẦU TIÊN sau khi Google trả về — cũng là lượt hay vấp lỗi lệch
    // đồng hồ nhất, vì vé vừa được ký xong đúng giây trước đó.
    window.thuLaiSQL(function () {
      return may.from('nguoi_dung').select('*').eq('id', phien.user.id).maybeSingle();
    }, function (lan) {
      if (vaoNhanh === uid) {
        window.baoTrangThai('cho', '⏳ Máy chủ của nhà trường đang khởi động lại, hệ thống tự thử lại (lần ' + lan +
          ')… Thầy cô đang xem dữ liệu đã lưu trên máy — chờ kết nối xong rồi hãy ghi.');
        return;
      }
      veCongDangTai('Máy chủ của nhà trường đang khởi động lại. ' +
        'Hệ thống tự thử lại (lần ' + lan + ')… thầy cô cứ để yên màn hình, ' +
        'KHÔNG cần bấm tải lại trang.');
    }).then(function (r) {
      if (r.error && vaoNhanh === uid) {
        idPhienDaXuLy = null;
        window.baoTrangThai('loi', '⚠️ Chưa kết nối được máy chủ: ' + thoat(r.error.message || '') +
          '. Thầy cô đang xem dữ liệu đã lưu trên máy — <b>tải lại trang trước khi ghi</b>.');
        return;
      }
      if (r.error) {
        idPhienDaXuLy = null;
        // Đã tự thử lại hết thang chờ mà vẫn hỏng: nói rõ máy đã thử rồi, để
        // thầy cô khỏi ngồi bấm tải lại thêm chục lần nữa cho cùng một lỗi.
        veCongLoi('Không đọc được hồ sơ tài khoản: ' + (r.error.message || '') +
          (loiChopNhoang(r.error)
            ? '. Hệ thống đã tự thử lại suốt hơn một phút mà máy chủ vẫn chưa trả lời. ' +
              'Thầy cô chờ ít phút rồi tải lại trang; nếu vẫn vậy thì báo quản trị viên.'
            : '. Thầy cô thử tải lại trang; nếu vẫn lỗi thì báo quản trị viên.'));
        return;
      }
      // Đăng nhập Google được nhưng CHƯA có dòng trong nguoi_dung: trigger tạo
      // hồ sơ chạy ngay sau khi Google trả về, đôi khi chậm hơn lần đọc này.
      // Coi như chờ duyệt và cho đăng xuất — KHÔNG mở khóa trang.
      if (vaoNhanh === uid && (!r.data || r.data.trang_thai !== 'hoat_dong')) { vaoNhanh = ''; xoaVaTaiLai(); return; }
      if (!r.data) {
        choDuyetHoacKhach(phien.user.email || '', false);
        return;
      }
      if (r.data.trang_thai === 'hoat_dong' && window.KHO_MAY) window.KHO_MAY.ghi(uid + '|vao|nd', r.data);
      // Đã vào nhanh: trang đang mở rồi, chỉ đối chiếu. Hồ sơ tài khoản đổi
      // (vai trò, điểm trường…) thì tải lại trang để mọi màn dựng theo quyền mới.
      if (vaoNhanh === uid) {
        if (khacNguoi(window.NGUOI_DUNG, r.data)) { location.reload(); return; }
        window.NGUOI_DUNG = r.data;
        window.baoTrangThai(null);
        may.from('nguoi_dung').update({ lan_vao_cuoi: new Date().toISOString() }).eq('id', r.data.id).then(function () {});
        if (window.napDuLieuThat) window.napDuLieuThat();   // khác bản lưu thì tự vẽ lại
        return;
      }
      if (r.data.trang_thai === 'hoat_dong') daVaoMang = true;
      window.NGUOI_DUNG = r.data;
      veKhuTaiKhoan();

      if (r.data.trang_thai === 'hoat_dong') {
        veCongDangTai();
        window.baoTrangThai(null);
        may.from('nguoi_dung').update({ lan_vao_cuoi: new Date().toISOString() }).eq('id', r.data.id).then(function () {});
        // Chờ dữ liệu thật nạp xong mới mở khóa. Nạp lỗi cũng mở — thà vào được
        // trang và thấy báo lỗi còn hơn kẹt mãi ở cổng.
        // Sự kiện 'dangnhap-xong' (cho các file bê từ Bạch Liêu sang, hocsinh.js,
        // dieu-hanh.js, dbcl-chi-tieu.js) phát SAU khi nạp xong — rà soát
        // 24/8/2026: trước đây phát ngay, trước khi bảng `cau_hinh` về, nên
        // hocsinh.js chọn năm từ CAU_HINH.NAM_HOC lúc còn là giá trị tính cục
        // bộ; trường khoá tay `nam_hoc` trong cau_hinh thì màn Học sinh mở
        // nhầm năm rồi băng vàng lại nói năm khác. Nạp lỗi vẫn phát — các màn
        // đó tự báo lỗi của mình, không nên kẹt vì cổng.
        var dangNap = window.napDuLieuThat && window.napDuLieuThat();
        function xongNap() {
          moKhoa();
          document.dispatchEvent(new Event('dangnhap-xong'));
        }
        if (dangNap && dangNap.then) dangNap.then(xongNap, xongNap);
        else xongNap();
        // Gọi cho MỌI vai: veQuanTri tự dọn màn khi không phải BGH/quản trị —
        // vai bị hạ giữa phiên thì các nút quản trị cũ không đứng lại (mục 100).
        window.veQuanTri && window.veQuanTri();
      } else {
        // cho_duyet hoặc khoa → giữ nguyên cổng, KHÔNG mở khóa trang
        choDuyetHoacKhach(r.data.email, r.data.trang_thai === 'khoa');
      }
    }, function (e) {
      // Đứt mạng giữa chừng thì lời hứa bị TỪ CHỐI chứ không trả về {error} —
      // không có nhánh này thì cổng đứng mãi ở dòng "Đang tự thử lại lần 6…".
      idPhienDaXuLy = null;
      if (vaoNhanh === uid) {
        window.baoTrangThai('loi', '⚠️ Mất kết nối tới máy chủ. Thầy cô đang xem dữ liệu đã lưu trên máy — ' +
          '<b>kiểm tra mạng rồi tải lại trang trước khi ghi</b>.');
        return;
      }
      veCongLoi('Không gọi được máy chủ khi đọc hồ sơ tài khoản: ' +
        ((e && e.message) || e) + '. Thầy cô kiểm tra đường mạng rồi tải lại trang.');
    });
  }

  // ── Khởi động ──
  // Chờ CẢ HAI: cây HTML dựng xong, và cauhinh.js tra xong địa chỉ này thuộc
  // trường nào. Cấu hình nay nằm ở tệp riêng (cau-hinh/…) nên phải tải về —
  // các cờ CHUA_CHON_TRUONG / DA_NOI chỉ có nghĩa SAU khi tải xong.
  function khiDomXong(viec) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', viec);
    else viec();
  }

  Promise.all([
    window.CAU_HINH_SAN_SANG,
    new Promise(function (ok) { khiDomXong(ok); })
  ]).then(function (kq) {
    var trangThai = kq[0];

    // ⛔ HÀNG RÀO 2 — chưa biết người vào thuộc trường nào (màn khai mã), hoặc
    //    không tải được cấu hình. Cả hai trường hợp js/cong-truong.js đang giữ
    //    màn hình; tệp này không có việc gì và TUYỆT ĐỐI không được gỡ khóa.
    if (trangThai === 'chua-biet' || trangThai === 'loi') return;

    // Chưa cấu hình CSDL (đang xem thử, hoặc trường chưa dựng Supabase) → phải
    // MỞ khóa vì trang khóa sẵn từ HTML. Không có nhánh này thì bản mẫu trắng màn.
    if (!window.DA_NOI) {
      document.body.classList.remove('dang-khoa');
      var congDemo = document.getElementById('cong-vao');
      if (congDemo) congDemo.classList.add('an');

      // 🔴 PHẢI NÓI RÕ TÌNH TRẠNG. Nhánh này trước đây return thẳng, mà
      //    veKhuTaiKhoan() nằm mãi phía dưới nên KHÔNG BAO GIỜ chạy → góc tài
      //    khoản là một ô rỗng, không tệp nào khác điền vào.
      //    Hậu quả thật: thầy admin trường mới gõ đúng mã, app mở ra mang đúng
      //    tên trường mình, đủ hồ sơ và thống kê — rồi thầy đi tìm nút đăng
      //    nhập để nhận quyền quản trị và KHÔNG THẤY Ở ĐÂU CẢ.
      //    Ở đây thật sự chưa có gì để đăng nhập (trường chưa dựng cơ sở dữ
      //    liệu), nên không dựng nút giả — nhưng phải nói cho người ta biết.
      var khuChua = document.getElementById('khu-tai-khoan');
      if (khuChua && window.CAU_HINH && window.CAU_HINH.MA) {
        khuChua.innerHTML =
          '<div class="chip-chua-mo" title="Trường chưa dựng cơ sở dữ liệu riêng">' +
          '<b>Chưa mở đăng nhập</b><small>Trường đang trong quá trình cài đặt</small></div>';
      }
      return;
    }

    if (!window.supabase || !window.supabase.createClient) {
      veCongLoi('Không tải được thư viện kết nối tới máy chủ. Thầy cô kiểm tra ' +
        'đường mạng rồi tải lại trang.');
      return;
    }
    may = window.supabase.createClient(window.CAU_HINH.DIA_CHI, window.CAU_HINH.KHOA_CONG_KHAI);
    window.MAY_CHU = may;

    veKhuTaiKhoan();
    thuVaoNhanh(uidDaNho());
    may.auth.getSession().then(function (r) { xuLyPhien(r.data ? r.data.session : null); });
    may.auth.onAuthStateChange(function (suKien, phien) {
      if (suKien === 'SIGNED_IN' || suKien === 'INITIAL_SESSION' || suKien === 'TOKEN_REFRESHED') xuLyPhien(phien);
      if (suKien === 'SIGNED_OUT') xuLyPhien(null);
    });
  });
})();

;} catch (e) { console.error("[goi.min.js] Lỗi khi nạp js/supabase-ket-noi.js:", e); }
